import { render, staticRenderFns } from "./GameReviewDetailAnswer.vue?vue&type=template&id=49903b78&scoped=true&"
import script from "./GameReviewDetailAnswer.vue?vue&type=script&lang=js&"
export * from "./GameReviewDetailAnswer.vue?vue&type=script&lang=js&"
import style0 from "./GameReviewDetailAnswer.vue?vue&type=style&index=0&id=49903b78&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49903b78",
  null
  
)

/* custom blocks */
import block0 from "./GameReviewDetailAnswer.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports